import React, { forwardRef } from 'react';
import { Alert } from '@mui/material';
import type { AlertColor } from '@mui/material/Alert';
import { closeSnackbar, SnackbarContent, type CustomContentProps } from 'notistack';

function variantToSeverity(variant: CustomContentProps['variant']): AlertColor {
  return variant === 'default' ? 'info' : variant;
}

export const OutlinedAlertSnackbar = forwardRef<HTMLDivElement, CustomContentProps>(
  function OutlinedAlertSnackbar({ id, message, variant, style, className }, ref) {
    return (
      <SnackbarContent
        ref={ref}
        role="alert"
        className={className}
        style={{
          padding: 0,
          backgroundColor: 'transparent',
          boxShadow: 'none',
          ...style,
        }}
      >
        <Alert
          severity={variantToSeverity(variant)}
          variant="outlined"
          onClose={() => closeSnackbar(id)}
          sx={{ width: '100%', bgcolor: 'background.paper' }}
        >
          {message}
        </Alert>
      </SnackbarContent>
    );
  }
);

export const outlinedNotistackComponents = {
  default: OutlinedAlertSnackbar,
  success: OutlinedAlertSnackbar,
  error: OutlinedAlertSnackbar,
  warning: OutlinedAlertSnackbar,
  info: OutlinedAlertSnackbar,
} as const;
